<div class="transitions-editor mt-5">
    <eas-workflow-transitions></eas-workflow-transitions>
    <eas-workflow-preview class="text-center"></eas-workflow-preview>
</div>
